module.exports = __webpack_public_path__ + "img/HZG_Logo_100_RGB.984bc9cc.png";